function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-gosag-logo"
}, "gosag");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-gosag-logo"
}, "gosag logo");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M577.06,658.6l-25,0V641.94c0-7.64-5.69-7.61-8-7.61-2,0-8,0-8,7.61v74.55c0,7.64,5.86,7.63,8,7.63,2.35,0,8,0,8-7.63V694.66H541.61V677.6H577v65H563v-8.92c-2.24,3.84-11.49,9.36-18.88,9.36-22.06,0-31.47-19.55-32-23.83a143,143,0,0,1-.94-19.3V641.07c0-11.88,14.17-25.63,33-25.63,19,0,32.91,15.43,32.94,25.63Z",
  transform: "translate(-511.14 -615.44)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M626.62,615.44h.53c18.69.13,32.69,13.82,32.69,25.63v76.28c0,11.84-13.94,25.48-32.62,25.66h-.53C608,742.83,594,729.19,594,717.35V641.07c0-11.8,14-25.49,32.62-25.63m.53,18.89h-.46c-2.22,0-7.8.29-7.8,7.61v74.55c0,7.34,5.58,7.61,7.8,7.61h.46c2.18,0,7.8-.27,7.8-7.61V641.94c0-7.32-5.62-7.61-7.8-7.61",
  transform: "translate(-511.14 -615.44)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M906.19,658.6l-24.91,0V641.94c0-7.64-5.72-7.61-8-7.61-2,0-8,0-8,7.61v74.55c0,7.64,5.86,7.63,8,7.63,2.34,0,8,0,8-7.63V694.66H870.73V677.6h35.46v65H892.12v-8.92c-2.17,3.84-11.5,9.36-18.87,9.36-22,0-31.44-19.55-32-23.83a152,152,0,0,1-.94-19.3V641.07c0-11.88,14.18-25.63,33-25.63,19,0,32.94,15.43,32.94,25.63Z",
  transform: "translate(-511.14 -615.44)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M809.15,618l14.29,124.53H800l-2.63-31.67H784.48l-2.64,31.67H758.4L772.7,618ZM796,694.47l-5.11-60.17-5,60.17Z",
  transform: "translate(-511.14 -615.44)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M741.47,658.6l-24.91,0V641.94c0-7.64-5.73-7.61-8-7.61-2,0-8,0-8,7.61l0,3.41c.1,1.22.1,2.28.27,3.36l.09.36.08.44.13.5.17.54.12.41.21.53.26.55.44.9c.17.33.37.71.61,1.1,1.29,1.68,2.92,3.73,4.75,5.93l26.54,30.55c8.66,10.05,8.15,20.55,8.15,20.55v6.28c0,11.91-14.13,25.66-33,25.66s-32.91-15.43-32.91-25.64V699.85h24.88v16.64c0,7.63,5.73,7.61,8,7.61,2,0,8.05,0,8.05-7.61v-3.41a22.86,22.86,0,0,0-.27-3.36l-.06-.37-.08-.42-.12-.5-.18-.56-.14-.4-.2-.51-.26-.55-.43-.9c-.2-.36-.4-.72-.64-1.11-1.28-1.69-2.92-3.75-4.73-5.94L683.7,667.93c-8.67-10-8.14-20.55-8.14-20.55v-6.31c0-11.88,14.17-25.63,33-25.63,19,0,32.92,15.43,32.92,25.63Z",
  transform: "translate(-511.14 -615.44)"
});

var SvgGosag = function SvgGosag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-gosag-logo desc-gosag-logo",
    viewBox: "0 0 395.05 127.56",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-gosag-logo"
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGosag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gosag.dd7ba182.svg";
export { ForwardRef as ReactComponent };